import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SITE } from "../../../lib/siteData";
import { fadeUp } from "../../../lib/motion";

export default function ServicesSection() {
  return (
    <section
      id="services"
      className="py-24 sm:py-32 bg-[#E5E5EA]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <motion.div
          {...fadeUp}
          className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16"
        >
          <div>
            <p className="text-[12px] uppercase tracking-[0.36em] text-[#011233] font-semibold mb-4">
              Coverage
            </p>
            <h2 className="font-heading font-bold text-4xl sm:text-6xl text-[#011233] leading-[1.02] tracking-tight">
              Built for every chapter.
            </h2>
          </div>
          <p className="text-base text-slate-600 max-w-md leading-relaxed">
            From your first car to your family business. Each line of coverage,
            quoted independently across 10+ carriers.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {SITE.services.map((s, idx) => {
            const isInternal =
              s.href && s.href.startsWith("/") && !s.href.startsWith("/#");
            const Wrapper = isInternal ? motion(Link) : motion.a;
            const wrapperProps = isInternal
              ? { to: s.href }
              : { href: s.href || "#quote" };
            return (
              <Wrapper
                key={s.slug}
                id={`service-${s.slug}`}
                {...wrapperProps}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.7,
                  ease: [0.22, 1, 0.36, 1],
                  delay: idx * 0.05,
                }}
                whileHover={{ y: -12 }}
                className="kn-svc group relative block rounded-[28px] bg-white overflow-hidden ring-1 ring-[#011233]/10"
                data-testid={`service-card-${s.slug}`}
              >
                <div className="aspect-[16/10] overflow-hidden bg-[#F0F0F2] relative">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.08]"
                  />
                </div>
                <div className="p-8 sm:p-9">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-heading font-bold text-[#011233] text-2xl sm:text-3xl tracking-tight leading-tight">
                      {s.title}
                    </h3>
                    <span className="mt-1 flex w-9 h-9 rounded-full bg-[#F0F0F2] text-[#011233] items-center justify-center transition-all duration-300 group-hover:bg-[#011233] group-hover:text-white flex-shrink-0">
                      <ArrowRight size={16} />
                    </span>
                  </div>
                  <p className="mt-3 text-slate-600 text-[15px] leading-relaxed">
                    {s.blurb}
                  </p>
                  <p className="mt-5 text-[12px] uppercase tracking-[0.22em] text-[#011233] font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {isInternal ? "Learn more" : "Get a quote"}
                  </p>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
